
  function gostart(){
    tab_product();
    getDate();
    setInterval(getDate, 1000);
     //slideLlx()
    
   }
   function tow(n) {
     return n >= 0 && n < 10 ? '0' + n : '' + n;
   }
   //倒计时函数  
   function getDate() {
     var oDate = new Date();//获取日期对象
     var oldTime = oDate.getTime();//现在距离1970年的毫秒数
     
     var newDate = new Date('2020/05/14 08:00:00'); //首页倒计时
     var newTime = newDate.getTime();//2019年距离1970年的毫秒数

     if((newTime-oldTime)<0){
     	$('.featured-flash-sale').hide()
     }else{
       
         var second = Math.floor((newTime - oldTime) / 1000);//未来时间距离现在的秒数

         var day = Math.floor(second / 86400);//整数部分代表的是天；一天有24*60*60=86400秒 ；

         second = second % 86400;//余数代表剩下的秒数；

         var hour = Math.floor(second / 3600);//整数部分代表小时；

         second %= 3600; //余数代表 剩下的秒数；

         var minute = Math.floor(second / 60);

         second %= 60;
         let days= tow(day)
         let hours= tow(hour)
         let minutes= tow(minute)
         let seconds= tow(second)
         $('.grid-center-days').html(days);
         $('.grid-center-Hours').html(hours);
         $('.grid-center-Mins').html(minutes);
         $('.grid-center-Secs').html(seconds);
     	
     }
     
   }
   
   function tab_product(){
	
     var len=$('.most-all').find('.most-li').length;
     
     $('.most-all').find('.most-li').click(function(event) {
       
       var index=$(".most-all .most-li").index(this);
       for(var i=0;i<len;i++){
         if(i==index){
         	$(".most-all .most-li").eq(i).addClass("cur")
            $(".featured_tab1").eq(i).addClass("lib");
         }else{
            $(".featured_tab1").eq(i).removeClass("lib");
         	$(".most-all .most-li").eq(i).removeClass("cur")
         }
       }
     });
     
      $('.product-promotion').find('.sp2').hover(function(){
     	 $('.product-promotion').find('.sp3').show()
     },function(){
		$('.product-promotion').find('.sp3').hide()
     })
     
      $('.product-make-imgbutton').click(function(event) {
        
		$('.product-make-img').find('.product-make-lis').css('height','auto');
//         $(".product-make-img").slideDown("slow");
        $('.product-make-imgbutton').hide();
        $('.product-make-imgshow').show();
        
      })
      
      $('.product-make-imgshow').click(function(event) {
        $('.product-make-img').find('.product-make-lis').css('height','');
//   		$(".product-make-img").slideUp("slow");
        $('.product-make-imgshow').hide();
        $('.product-make-imgbutton').show();
      })
      
      $(".grid-orders-tab").click(function(event){
        $(".grid-orders-tab").addClass('cur')
         $(".grid-details-tab").removeClass('cur')
      	$('.grid-nike-luke').find('.medium-up--two-thirds').show()
        $('.grid-nike-luke').find('.medium-up--one-third').hide()
      });
     
     $('.grid-details-tab').click(function(event) {
		 $(".grid-orders-tab").removeClass('cur')
         $(".grid-details-tab").addClass('cur')
        $('.grid-nike-luke').find('.medium-up--two-thirds').hide()
        $('.grid-nike-luke').find('.medium-up--one-third').show()
       });
     
     
     $('.clearance-list').find('.list-img').hover(function(){
        $(this).find('.list-btn').show();

     },function(){
       $(this).find('.list-btn').hide();

     });
     
     $('.buyone-getone-all').find('.product-img').hover(function(){
        $(this).find('.btm-shop').show();

     },function(){
       $(this).find('.btm-shop').hide();

     });
     
     $('.vape-devices-txt').find('.text-top').find('span').click(function(){
     	$('.vape-devices-txt').find('.text-bottom').show();
        $(this).hide();
     });
     
     $('.vape-devices-txt').find('.text-bottom').find('.btm-less').find('span').click(function(){
       $('.vape-devices-txt').find('.text-bottom').hide();
       $('.vape-devices-txt').find('.text-top').find('span').show();
     });
     
      $('.close-festival').click(function(){
      	$('.main-activity').hide()
      })
     
      setTimeout(function(){
        $('.main-activity').animate({bottom:'-356'},1500)
      },5000)
       
     $('.sidebar .rit').click(function(){
       $('.sidebar').hide();
       $('.sidebarlet').show();
     
     });
     $('.sidebarlet').click(function(){
       $('.sidebar').show();
     	$('.sidebarlet').hide();
     
     });
     
   }

   $(function(){
   	gostart()
    
    $(".grid-flash-center").find('li').css({width:$(".grid-flash-center").width()})
    $(".grid-flash-center").find('li').css({height:$(".grid-flash-center").height()})
    let len=$(".grid-flash-center").find('li').length;
     if(len<2){
     	$('.grid-flash-nav').hide();
     }
    $(".grid-flash-center").YuxiSlider({
        width:$(".grid-flash-center").width(), //容器宽度
        height:$(".grid-flash-center").height(), //容器高度
        control:$('.grid-flash-nav'), //绑定控制按钮
        during:4000, //间隔4秒自动滑动
        speed:1200, //移动速度0.8秒
        mousewheel:true, //是否开启鼠标滚轮控制
        direkey:true //是否开启左右箭头方向控制
    });
   	
     $(window).scroll(function(){
      var top = $(window).scrollTop();
        if(top>230){
        
          $('.sloole').addClass('addscrolltopshow')
           $('.sloole').find('.megamenu').addClass('addscrolltopauto')
        }else{
        	$('.sloole').removeClass('addscrolltopshow')
             $('.sloole').find('.megamenu').removeClass('addscrolltopauto')
        }

       })
     
   });
 	
